import { useState, useEffect } from 'react';
import SimpleHeader from '@/containers/header';
import Footer from '@/containers/footer';
import { grid } from '@/constants/grid';
import Header from '@/bit/components/components.header';
import { isWebViewFromCookie } from '@/utils/cookiesHelper';
import { useSelector } from 'react-redux';

const Page = ({ pageId, children, showMainHeader = false, loaded = true }) => {
  const headerProps = useSelector((state) => state.header);
  const [isWebViewClass, setIsWebViewClass] = useState('');

  useEffect(() => {
    setIsWebViewClass(isWebViewFromCookie() ? 'hidden-content' : '');
  }, []);

  return (
    <div id={pageId} className="page" data-cy={pageId}>
      {loaded && !showMainHeader && (
        <div className={`header ${isWebViewClass}`}>
          <div className="container">
            <div className="row">
              <div className="page__header col-sm-12">
                <SimpleHeader cyData={`${pageId}__header`} />
              </div>
            </div>
          </div>
        </div>
      )}
      {loaded && showMainHeader && <Header {...headerProps} />}
      {children}
      {loaded && (
        <div className={`footer ${isWebViewClass}`}>
          <Footer cyData={`${pageId}__footer`} />
        </div>
      )}
      <style jsx>
        {`
          .page {
            display: flex;
            flex-direction: column;
            min-height: ${showMainHeader
              ? 'calc(calc(var(--vh, 1vh) * 100) - 60px)'
              : ' calc(var(--vh, 1vh) * 100)'};
            .page__header {
              margin-top: 18px;
              margin-bottom: 20px;
            }
            :global(.footer) {
              margin-top: auto;
            }
          }
          .hidden-content {
            pointer-events: none;
          }
          @media screen and (min-width: ${grid.breakpoint_sm}px) {
            .page {
              .page__header {
                margin-top: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
          @media screen and (min-width: ${grid.breakpoint_lg}px) {
            .page {
              min-height: ${showMainHeader
                ? 'calc(calc(var(--vh, 1vh) * 100) - 80px)'
                : ' calc(var(--vh, 1vh) * 100)'};
            }
            .col-form-header {
              display: grid;
              grid-column-start: 2;
              grid-column-end: 12;
            }
          }
        `}
      </style>
    </div>
  );
};
export default Page;
